import { isFunction } from '../../helpers';
import {
  BOOKING_CLOSED,
  fetchBookingClosedMessageAction,
} from '../siteDucks/bookingClosed';
import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

const UPDATE = 'BILLING_DETAILS_UPDATE';
const SUCCESS = 'BILLING_DETAILS_SUCCESS';
const FAILURE = 'BILLING_DETAILS_FAILURE';

const initialState = {
  loaded: false,
  data: {},
  meta: {},
};

export default function billingDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: 200,
          booking: action.data.statusCode !== 423,
          ...action.data.json,
        },
      );

    case BOOKING_CLOSED:
      return Object.assign(
        {},
        {
          loaded: true,
          ...action.data.json,
          statusCode: 423,
        },
      );

    case FAILURE:
      return Object.assign({}, state, {
        error: true,
        statusCode: action.data.statusCode,
        ...action.data.json,
      });

    default:
      return state;
  }
}

export function fetchBillingDetailsSuccess(data) {
  return { type: SUCCESS, data };
}

export function updateBillingDetailsSuccess(data) {
  return { type: UPDATE, data };
}

export function billingDetailsFailure(data) {
  return { type: FAILURE, data };
}

export function fetchBillingDetailsAction(basketId) {
  return function (dispatch, getState, { Api, qs, i18n }) {
    const {
      pageConfig: { previewMode, siteId },
    } = getState();

    return Api()
      .service('CommerceService')
      .version('v1')
      .setup({
        method: 'GET',
        headers: {
          'Accept-Language': i18n.language,
          'Content-Type': 'application/json',
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .billingDetails({ siteId, basketId })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchBillingDetailsSuccess(response));
        } else if (response.statusCode === 423) {
          return dispatch(fetchBookingClosedMessageAction());
        } else {
          return dispatch(billingDetailsFailure(response));
        }
      });
  };
}

export function updateBillingDetailsAction(basketId, bodyParams, callback) {
  return function (dispatch, getState, { Api, qs, i18n }) {
    const {
      pageConfig: { previewMode, siteId },
    } = getState();

    return Api()
      .service('CommerceService')
      .version('v1')
      .setup({
        method: 'PUT',
        headers: {
          'Accept-Language': i18n.language,
          'Content-Type': 'application/json',
          'Published-State': getPublishedStateHeader(previewMode),
        },
        body: JSON.stringify(bodyParams),
      })
      .billingDetails({ siteId, basketId })
      .then((response) => {
        if (isFunction(callback)) {
          const data = {
            statusCode: response.statusCode,
            ...response.json,
          };

          callback(data);
        }

        if (response.statusCode === 200) {
          return dispatch(updateBillingDetailsSuccess(response));
        } else {
          return dispatch(billingDetailsFailure(response));
        }
      });
  };
}
